var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',[_c('Multiselect',{attrs:{"placeholder":"Theme","track-by":"id","label":"name","options":_vm.themeOptions,"allow-empty":false},on:{"input":_vm.onInput},model:{value:(_vm.theme),callback:function ($$v) {_vm.theme=$$v},expression:"theme"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }